import React from 'react'
import useStyles, { useStylesChip } from './styles'
import { Show as ShowData } from 'data/Show'
import moment from 'moment'
import clsx from 'clsx'
import { formatTime } from 'utils/date'
import { showHasStarted, showHasEnded } from 'utils/show'
import LazyImage from 'components/common/LazyImage/LazyImage'
import placeholder from 'assets/placeholder.png'

interface ShowProps {
    show: ShowData
    featured?: boolean
    className?: string
    onClick?: (ShowData) => void
    times?: number
}

export const Chip = React.memo(({ children }) => {
    const classes = useStylesChip()
    return (
        <div className={classes.chip}>
            <p className={classes.chipText}>{children}</p>
        </div>
    )
})

const Show: React.FC<ShowProps> = ({ show, times = 1, featured = false, className, onClick }) => {
    const classes = useStyles({ featured })
    const isLive = showHasStarted(show) && !showHasEnded(show)

    const Bottom = ({ className }) => (
        <div className={clsx(className, classes.info)}>
            <h1 className={classes.title}>{show.title}</h1>
            {times > 1 ? <Chip>{times} event times</Chip> : <Chip>{formatTime(show.startTime)}</Chip>}
        </div>
    )

    return (
        <>
            <div
                onClick={() => onClick && onClick(show)}
                className={clsx(className, { [classes.featured]: featured }, classes.container)}
            >
                <LazyImage src={show.posterImg} thumb={placeholder} className={classes.image} />
                {!isLive ? (
                    <div className={clsx(classes.status, classes.time)}>
                        <p className={classes.day}>{moment(show.startTime).format('DD')}</p>
                        <p className={classes.month}>{moment(show.startTime).format('MMM')}</p>
                    </div>
                ) : (
                    <div className={clsx(classes.status, classes.live)}>
                        <div className={classes.liveDot}>
                            <div />
                        </div>
                        <p className={classes.liveText}>Live</p>
                    </div>
                )}
                {!featured && <Bottom className={classes.bottomCard} />}
            </div>
            {!featured && <Bottom className={classes.bottom} />}
        </>
    )
}

export default React.memo(Show)
